export default __webpack_public_path__ + "static/media/veksla_logo_no_text.d4d0bb8b.svg";